class CompleteTheLook extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.limit = parseInt(this.dataset.limit, 10) || 4;
    this.intent = this.dataset.intent || 'complementary';
    this.grid = this.querySelector('[data-grid]');
    try {
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'fr-FR', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR'
      });
    } catch (e) {
      this.formatter = { format: (v) => v.toFixed(2).replace('.', ',') + ' €' };
    }
    this.render();
  }

  async render() {
    if (!this.grid || !this.productId) {
      this.remove();
      return;
    }
    try {
      const url = '/recommendations/products.json?product_id=' + encodeURIComponent(this.productId)
        + '&intent=' + encodeURIComponent(this.intent)
        + '&limit=' + this.limit;
      const response = await fetch(url);
      if (!response.ok) {
        this.remove();
        return;
      }
      const data = await response.json();
      const products = (data.products || []).slice(0, this.limit);
      if (!products.length) {
        this.remove();
        return;
      }
      this.grid.innerHTML = products.map((p) => this.renderCard(p)).join('');
      this.classList.remove('is-loading');
      this.classList.add('is-loaded');
      this.removeAttribute('hidden');
    } catch (e) {
      this.remove();
    }
  }

  renderCard(product) {
    const image = product.featured_image
      ? (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.url || product.featured_image)
      : (product.images && product.images[0]) || '';
    const imageUrl = image
      ? (image.includes('?') ? image + '&width=600' : image + '?width=600')
      : '';
    const showVendor = this.dataset.showVendor === 'true';
    const vendor = showVendor && product.vendor
      ? '<p class="complete-the-look-mtij__card-vendor">' + this.escape(product.vendor) + '</p>'
      : '';
    const soldOut = product.available === false
      ? '<span class="complete-the-look-mtij__card-soldout">' + this.escape(this.dataset.i18nSoldOut || 'Sold out') + '</span>'
      : '';
    const price = this.formatter.format((product.price || 0) / 100);
    const onSale = product.compare_at_price && product.compare_at_price > product.price;
    const compareAt = onSale ? this.formatter.format(product.compare_at_price / 100) : '';
    const priceMarkup = onSale
      ? '<div class="price price--on-sale">' +
          '<div class="price__container">' +
            '<div class="price__sale">' +
              '<span><s class="price-item price-item--regular">' + compareAt + '</s></span>' +
              '<span class="price-item price-item--sale price-item--last">' + price + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      : '<div class="price">' +
          '<div class="price__container">' +
            '<div class="price__regular">' +
              '<span class="price-item price-item--regular">' + price + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    const altText = (product.featured_image && product.featured_image.alt) || product.title;

    const url = this.escape(product.url);
    const quickBuyLabel = this.escape(
      (this.dataset.i18nQuickBuy || 'Quick view — [title]').replace('[title]', product.title)
    );

    // Mirrors the Liquid branch: the card is a <div>, because a <button> may not
    // be nested inside an <a>. Hover rules key on the card class, not the link.
    return [
      '<div class="complete-the-look-mtij__card" role="listitem">',
      '<div class="complete-the-look-mtij__card-media">',
      '<a class="complete-the-look-mtij__card-media-link" href="' + url + '" tabindex="-1" aria-hidden="true"></a>',
      soldOut,
      imageUrl
        ? '<img class="complete-the-look-mtij__card-image" src="' + this.escape(imageUrl) + '" alt="' + this.escape(altText) + '" loading="lazy">'
        : '',
      '<button type="button" class="quick-buy-trigger" data-quick-buy data-product-url="' + url + '"',
      ' aria-haspopup="dialog" aria-controls="QuickBuyDialog" aria-label="' + quickBuyLabel + '">',
      this.dataset.iconQuickBuy || '+',
      '</button>',
      '</div>',
      '<a class="complete-the-look-mtij__card-link" href="' + url + '">',
      '<div class="complete-the-look-mtij__card-details">',
      vendor,
      '<h3 class="complete-the-look-mtij__card-title">' + this.escape(product.title) + '</h3>',
      '<div class="complete-the-look-mtij__card-price">',
      priceMarkup,
      '</div>',
      '</div>',
      '</a>',
      '</div>'
    ].join('');
  }

  escape(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }
}

if (!customElements.get('complete-the-look')) {
  customElements.define('complete-the-look', CompleteTheLook);
}
